<template>
  <div class="blur-options">
    <button :key="v" :class="{'item': true, 'active': value == v}" v-for="v in values" v-on:click="select(v)" data-hj-suppress>
      <span ref="background" class="background" v-bind:style="{'background-image': `url('${rotatedBackgroundUrl}')`, 'filter': `blur(${v}px)`, '-webkit-filter': `blur(${v/4}px)`}"></span>
      <div class="foreground-thumbnail" v-bind:style="{'background-image': foregroundUrl ? `url('${foregroundUrl}')` : ''}"></div>
    </button>
  </div>
</template>

<script>
import loadSuggestions from '../src/image_suggestions';
import {BrowserCompatibility,EXIF} from '../src/remove-bg-tools';
var CanvasExifOrientation = require('canvas-exif-orientation');

export default {
  props: {
    value: Number,
    foregroundUrl: String,
    backgroundUrl: String,
  },
  data: function() {
    return {
      values: [0, 4, 8, 22],
      rotatedBackgroundUrl: ''
    }
  },
  watch: {
    backgroundUrl: function(val) {
      this.updateBackgrounds();
    }
  },
  mounted: function() {
      if(this.backgroundUrl) {
        this.updateBackgrounds();
      }
  },
  methods: {
    updateBackgrounds() {
      let vm = this;
      this.loadImage(this.backgroundUrl).then((img) => {
        this.getEXIFOrientation(img).then((orientation) => {
          var canvas = CanvasExifOrientation.drawImage(img, orientation);

          var resizedCanvas = document.createElement('canvas');
          resizedCanvas.width = vm.$refs.background[0].clientWidth; // they are all the same size
          resizedCanvas.height = vm.$refs.background[0].clientHeight;

          const {
            offsetX,
            offsetY,
            width,
            height
          } = this.fit(false, resizedCanvas.width, resizedCanvas.height, canvas.width, canvas.height)
          resizedCanvas.getContext("2d").drawImage(canvas, offsetX, offsetY, width, height)

          this.rotatedBackgroundUrl = resizedCanvas.toDataURL("image/png");
        });
      }).catch((e) => {
        console.error(e);
      })
    },
    select: function(v) {
      this.$emit("change", {newValue: v});
    },
    loadImage: function(url) {
      return new Promise((resolve, reject) => {
        var img = new Image();
        img.crossOrigin = 'anonymous';

        img.onload = (e) => {
          resolve(img);
        };
        img.onerror = (e) => {
          reject("Image download failed.");
        }

        img.src = url;
      });
    },
    getEXIFOrientation: function(image) {
      return new Promise((resolve, reject) => {
        var needsExifProcessing = false;
        if (!BrowserCompatibility.supportsNativeExif(navigator.userAgent)) { // never apply exif rotation for browser that have native support
          var isJpeg = image.src.includes(".jpg") || image.src.includes(".jpeg"); // exif only for jpeg images
          if (isJpeg) {
            needsExifProcessing = true;
          } else if (image.src.includes("blob:")) { // or blobs
            needsExifProcessing = true;
          }
        }
        if (needsExifProcessing) {
          EXIF.getData(image, () => {
            resolve(image.exifdata.Orientation ? image.exifdata.Orientation : 1);
          });
        } else {
          resolve(1);
        }
      });
    },
    fit: function(contains, parentWidth, parentHeight, childWidth, childHeight, scale = 1, offsetX = 0.5, offsetY = 0.5) {
      // taken from https://stackoverflow.com/questions/21961839/simulation-background-size-cover-in-canvas
      const childRatio = childWidth / childHeight
      const parentRatio = parentWidth / parentHeight
      let width = parentWidth * scale
      let height = parentHeight * scale

      if (contains ? (childRatio > parentRatio) : (childRatio < parentRatio)) {
        height = width / childRatio
      } else {
        width = height * childRatio
      }

      return {
        width,
        height,
        offsetX: (parentWidth - width) * offsetX,
        offsetY: (parentHeight - height) * offsetY
      }
    }
  }
}
</script>

<style scoped>
  .blur-options {
    padding: 0;
    margin: 0;
    margin-left: -10px;
    margin-right: -10px;
    display: -webkit-flex;
    display: flex;
    overflow: auto;
  }
  .blur-options .item {
    margin: 0 10px;
    width: 80px;
    height: 80px;
    border: #6f6f6f;
    flex: 0 0 auto;
    outline: none;
    border: 1px solid #6f6f6f;
    position: relative;
    overflow: hidden;
  }
  .blur-options .item + .item {
    margin-left: 0;
  }
  .blur-options .item.active {
    border-color: #fff;
  }
  .blur-options .item .foreground-thumbnail {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    z-index: 20;
  }

  .background {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
    background-position: center;
    background-size: cover;
  }

  @media(min-width: 768px) {
    .blur-options {
      flex-wrap: wrap;
      margin-left: -5px;
      margin-right: -5px;
    }
    .blur-options .item {
      margin: 0 5px 10px 5px;
    }
    .blur-options .item.active {
    }
    .blur-options .item + .item {
      margin-left: 5px;
    }
  }
</style>
